import {
  IError,
  IProfile,
  IQueryHookOptions,
  IUpdateProfileRequest,
} from '@comptia-sso/core';
import {
  UseMutateAsyncFunction,
  useMutation,
  useQueryClient,
} from 'react-query';

// Services.
import { updateProfilePopuli } from 'services';

type UpdateProfilePopuliFunction = UseMutateAsyncFunction<
  IProfile,
  IError,
  IUpdateProfileRequest
>;

type UseUpdateProfilePopuli = [UpdateProfilePopuliFunction, IQueryHookOptions];

export const useUpdateProfilePopuli = (id = ''): UseUpdateProfilePopuli => {
  const queryClient = useQueryClient();
  const { error, isError, isLoading, mutateAsync } = useMutation<
    IProfile,
    IError,
    IUpdateProfileRequest
  >((values: IUpdateProfileRequest) => updateProfilePopuli(id, values), {
    onSuccess: (data) => {
      queryClient.setQueryData('profile', data);
    },
  });

  return [mutateAsync, { error, isError, isLoading }];
};
